import React from "react";
import Logo from '../assets/logo.png'
import { Button } from "@mui/material";

const Footer = ()=>{
    return (
        <div className="bg-footer px-5 pt-5 pb-1" data-aos='fade-in'>
            <div className="row w-100 mx-0">
                <div className="col-md-3" data-aos='fade-up'>
                    <img src={Logo} className="img-fluid me-1" />
                    <img src={require('../assets/oauife.png')} className="navbar-brand ms-1" />
                </div>
                <div className="col-md-8 col-lg-6" data-aos='fade-up'>
                    <div className="d-flex flex-md-row flex-column pt-2">
                        <div className="me-md-5">
                            <p className="fs-5 fw-bold text-yrh">
                                Quick Links
                            </p>
                            <a href="https://oauife.edu.ng" target="_blank" className="text-decoration-none fs-6 text-yrh d-block py-1">
                                OAU Website
                            </a>
                            <a href="/" className="text-decoration-none fs-6 text-yrh d-block py-1">
                                Home
                            </a>
                            <a href="/about" className="text-decoration-none fs-6 text-yrh d-block py-1">
                                About Us
                            </a>
                            <a href="/publications" className="text-decoration-none fs-6 text-yrh d-block py-1">
                                Publication
                            </a>
                        </div>
                        <div className="ms-md-5">
                            <Button className="rounded-0 bg-yrh text-white fw-bold">
                                Contact Us
                            </Button>
                            <a href="tel:+2348189488223" className="text-yrh py-3 fw-bold-0 fs-5 d-block text-decoration-none">
                                +234-8189488223
                            </a>
                            <div className="d-flex">
                                <img className="img-fluid me-2 cursor-pointer" onClick={()=>window.open('https://instagram.com/youngresearchershub_oau')} src={require('../assets/instagram_icon.png')} />
                                <img className="img-fluid me-2 cursor-pointer" onClick={()=>window.open('https://twitter.com/YRH_OAU')} src={require('../assets/x_icon.png')} />
                                <img className="img-fluid me-2 cursor-pointer" onClick={()=>window.open('mailto:youngresearchershuboau@gmail.com')} src={require('../assets/mail_icon.png')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <hr/> */}
            <p className="text-center text-yrh pt-4" data-aos='slide-in'>
                CopyRight &copy; 2023. All rights reserved.
            </p>
        </div>
    )
}

export default Footer